import React from "react";
import { Dayjs } from "dayjs";
import { ConfigProvider, Calendar } from "antd";
import styled from "styled-components";

const StyledCalendarWrapper = styled.div`
  font-family: "Aperçu", sans-serif;
  .ant-picker-calendar {
    font-size: 12px;
    width: 300px;
    padding: 8px;
  }
`;

const customTheme = {
  token: {
    colorPrimary: "#20e290",
  },
};

const SmallCalendar = ({ onSelectDate }: CalendarPickerProps): JSX.Element => {
  return (
    <ConfigProvider theme={customTheme}>
      <StyledCalendarWrapper key={`wrapper`}>
        <Calendar fullscreen={false} onSelect={onSelectDate} />
      </StyledCalendarWrapper>
    </ConfigProvider>
  );
};

export const getCalendarPickerOption = ({
  onSelectDate,
}: CalendarPickerProps): JSX.Element => (
  <SmallCalendar onSelectDate={onSelectDate} />
);

type CalendarPickerProps = {
  onSelectDate: (date: Dayjs) => void;
};

export default SmallCalendar;
